"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_controls_1 = require("owa-options-controls");
var HelpLink_1 = require("./HelpLink");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_session_store_1 = require("owa-session-store");
var owa_options_core_1 = require("owa-options-core");
var selectLinkPreviewIsEnabledOption_1 = require("../actions/selectLinkPreviewIsEnabledOption");
var LinkPreviewFull = /** @class */ (function (_super) {
    tslib_1.__extends(LinkPreviewFull, _super);
    function LinkPreviewFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinkPreviewFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.isEnabled, userOptions.LinkPreviewEnabled);
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null,
                owa_options_strings_1.default.options_mail_linkPreviewDescription,
                "\u00A0",
                React.createElement(HelpLink_1.default, { helpId: "LinkPreview" })),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: isEnabled, label: owa_options_strings_1.default.options_mail_linkPreviewCheckboxLabel, onChange: this.toggleEnable })));
    };
    LinkPreviewFull.prototype.toggleEnable = function (ev, checked) {
        selectLinkPreviewIsEnabledOption_1.default(checked);
    };
    LinkPreviewFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], LinkPreviewFull);
    return LinkPreviewFull;
}(React.Component));
exports.default = LinkPreviewFull;
//# sourceMappingURL=LinkPreviewFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-link-preview-option/lib/components/LinkPreviewFull.js
// module id = 5138
// module chunks = 2